import type { ToastOptions } from 'react-toastify';
import { Bounce, toast } from 'react-toastify';

const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

const toastOptions = (): ToastOptions => ({
  position: isMobile() ? 'top-center' : 'bottom-right',
  autoClose: isMobile() ? 3000 : 5000,
  hideProgressBar: isMobile(),
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  theme: 'dark',
  transition: Bounce,
  style: {
    zIndex: 99999,
    ...(isMobile() && { fontSize: '0.875rem', minHeight: 'unset', padding: '8px 12px' }),
  },
});

export const toastError = (message: string) => {
  toast.error(message, toastOptions());
};
export const toastSuccess = (message: string) => {
  toast.success(message, toastOptions());
};
